import React from 'react'
import LayoutMain from "../../../components/Layout/Main/Main";
import LeftSidedImageCopyItemCollection from "../../../Partials/LeftSidedImageCopyItem/collection";
import ProjectImageDatePageCollection from "../../../Partials/ProjectImageDetailPage/Collection";
import BannerWithButton from "../../../Partials/BannerWithButton/index";


const leftSidedImageCopyItemCollectionData = [
    {
        description : [
            'With a brief to optimise the outdoor spaces for practical entertaining large sliding doors  were fitted to the kitchen and dining areas allowing the once neglected garden to feel connected to the home once again. Works included a pool renovation with new glass fencing, bench seating and generous entertaining areas adjacent to the kitchen. A new large format contemporary tile was applied to all surfaces from the kitchen,  and living areas within the home through to the alfresco dining, steps and pool areas emphasising the connection between indoors and out.',
            'Hardwood timber bench seating was used to reference the new timber doors and existing kitchen.  A mixture of traditional and contemporary planting combine to provide the necessary structure to the outdoor spaces while still feeling relaxed. A large existing deciduous tree provides screening and shade in summer while allowing light to penetrate the garden in the winter.'
        ],
        descriptionContent : (
            <p>
            <span className="line">
            <b>Services Undertaken</b>
            <br/>
            </span>
            
            <b>Design Features</b>
            <br/>
            </p>
        ),
        image : '../images/projects/mosman-1.jpg',
        title : 'Mosman'
    }
]

const projectImageDetailPageCollectionData = [
    {
        dataId : 'a1',
        image : '../images/projects/mosman-1.jpg'
    },
    {
        dataId : 'a8',
        image : '../images/projects/mosman-2.jpg'
    },
    {
        dataId : 'a2',
        image : '../images/projects/mosman-3.jpg'
    },
    {
        dataId : 'a4',
        image : '../images/projects/mosman-4.jpg'
    },
    {
        dataId : 'a3',
        image : '../images/projects/mosman-5.jpg'
    },
    {
        dataId : 'a5',
        image : '../images/projects/mosman-6.jpg'
    },
]

const PageMosman = () => {
  return (
    <LayoutMain>
          <section className="about-top">
        <div className="container-3">
          <LeftSidedImageCopyItemCollection
            data={leftSidedImageCopyItemCollectionData}
          />
        </div>
      </section>
      <section className="pb-100">
        <div className="container-3">
          <div className="row">
            <ProjectImageDatePageCollection
              data={projectImageDetailPageCollectionData}
            />
          </div>
        </div>
      </section>
      <BannerWithButton />
        </LayoutMain>
  )
}

export default PageMosman